





























import Vue from "vue";
import { mapMutations } from "vuex";

import { ADD_ALERT } from "@/store/modules/AlertModule/mutations";
import { AlertModel, AlertModelType } from "@/store/modules/AlertModule/types";
import { ForceUpdateCheckCommand, ForceUpdateCheckReqData } from "@/model/communication/updatesStatus/ForceUpdateCheckCommand";

export default Vue.extend({
    props: {
        devices: Array,
    },
    data() {
        return { cardLoading: false };
    },
    methods: {
        ...mapMutations([ADD_ALERT]),
        async forceCheckDevices() {
            this.cardLoading = true;
            var response = await new ForceUpdateCheckCommand(new ForceUpdateCheckReqData(this.devices)).execute();
            this.cardLoading = false;

            if (response.data.Response == 0) {
                this[ADD_ALERT](
                    new AlertModel(AlertModelType.Success, `${this.$tc("device_update_status.force_update_check_devices", this.devices.length)}: ${this.$t("common.done")}`),
                    null
                );
            } else {
                this[ADD_ALERT](
                    new AlertModel(
                        AlertModelType.Error,
                        `${this.$tc("device_update_status.force_update_check_devices", this.devices.length)}: ${this.$t("common.error")} - ${response.data.Message}`
                    ),
                    null
                );
            }

            this.$emit("close");
        },
    },
});
